import { get, post, put, patch } from "../../../../services/api/Config"

const _api_route = `esg-highlight2`



// ========== Category Page ========== //
export function SearchContentCate({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route}`, params, lang })
}
export function GetContentCateById({ id, lang }) {
  return get({ url: `/v1/admin/${_api_route}/${id}`, lang })
}
export function CreateContentCate({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}`, params, data, lang })
}
export function UpdateContentCate({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${_api_route}/${id}`, params, data, lang })
}
export function PatchContentCate({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${_api_route}/${id}`, params, data, lang })
}
export function DeleteContentCate({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/mutiDelete`, params, data, lang })
}
